import { Directive, ElementRef, HostListener, Inject, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: 'input[required]:not([type=file]), textarea[required]'
})
export class InputTrimDirective {
    // Get a value of the trim attribute if it was set.
    @Input() trim: string;

    @Input()
    set type(value: string) {
        this._type = value || 'text';
    }

    /**
     * Keep the type of input element in a cache.
     *
     * @type {string}
     * @private
     */
    private _type = 'text';

    /**
     * Keep the value of input element in a cache.
     *
     * @type {string}
     * @private
     */
    private _value: string;

    // Source services to modify elements.
    private _sourceRenderer: Renderer2;
    private _sourceElementRef: ElementRef;

    /**
     * Updates the value on the blur event.
     */
    @HostListener('blur', ['$event.type', '$event.target.value'])
    onBlur(event: string, value: string): void {
        this.updateValue(event, value.trim());
    }

    /**
     * Updates the value on the input event.
     */
    @HostListener('input', ['$event.type', '$event.target.value'])
    onInput(event: string, value: string): void {
        this.updateValue(event, value);
    }

    constructor(
        @Inject(Renderer2) renderer: Renderer2,
        @Inject(ElementRef) elementRef: ElementRef
    ) {
        this._sourceRenderer = renderer;
        this._sourceElementRef = elementRef;
    }

    /**
     * Writes a new value to the element based on the type of input element.
     *
     * @param {any} value - new value
     */
    public writeValue(value: any): void {

        this._value = value === '' ? '' : value || null;

        this._sourceRenderer.setProperty(this._sourceElementRef.nativeElement, 'value', this._value);

        if (this._type !== 'text') {
            this._sourceRenderer.setAttribute(this._sourceElementRef.nativeElement, 'value', this._value);
        }
    }

    /**
     * Trims an input value, and sets it to the model and element.
     *
     * @param {string} value - input value
     * @param {string} event - input event
     */
    private updateValue(event: string, value: string): void {
        // check if the user has set an optional attribute, and Trim!
        value = this.trim !== '' && event !== this.trim ? value : value.trim();

        if (value[0] === ' ') {
            value = value.substr(1);
        }

        // write value to the element.
        this.writeValue(value);
    }
}
